import { Button, Input, Select } from 'antd';
import React, { useEffect, useState } from 'react';

const HeaderModal = ({
  handleHeaderColumnChange,
  headerVal,
  setheaderModalError,
  setHeaderVal,
  columnList: propColumnList,
  headerErrorModal,
  headerValFrom,
  dmnData,
  selectedColumn,
  setSelectedColumn,
  selectedColumnFromType,
  setSelectedColumnFromType,
}: any) => {
  const { Option } = Select;
  const [columnList, setColumnList] = useState<any[]>([]);

  console.log(headerValFrom, propColumnList)

  useEffect(() => {
    if (propColumnList?.length > 0 && headerValFrom) {

      const type = propColumnList.find((item) => item?.name?.toLowerCase() === headerValFrom?.toLowerCase())?.type || '';
      if (type) {
        setColumnList(propColumnList.filter((item) => item.type === type))
      } else {
        setColumnList(propColumnList)
      }
    }
  }, [headerValFrom, propColumnList]);

  return (
    <div>
      {dmnData?.inputFields.map((item: any) => item.name).includes(headerValFrom) ? (
        <>
          <h4>Select Header Column</h4>
          <div className="modal-container">
            <Select
              value={headerVal}
              className="select-menu dmb-4"
              onChange={(e) => {
                setHeaderVal(e);
                setheaderModalError('');
              }}
              showSearch
              style={{ width: '30%' }}
            >
              {columnList.length > 0 ? (
                columnList.map((item: any) => (
                  <Option key={item?.name} value={item?.name}>
                    {item.name}
                  </Option>
                ))
              ) : (
                <Option value="" disabled>
                  No options available
                </Option>
              )}
            </Select>
            <div style={{ color: 'var(--danger-500, red)' }}>{headerErrorModal || ''}</div>
          </div>
          <div className="modal-footer">
            <button
              className={`modal-submit-button ${!headerVal ? 'disabled' : ''}`}
              onClick={() => {
                handleHeaderColumnChange('input');
              }}
              disabled={!headerVal}
            >
              Submit
            </button>
          </div>
        </>
      ) : (
        <div>
          <h4>Enter Column Name</h4>
          <Input
            className="input-field-style dmb-4"
            value={selectedColumn}
            style={{ width: '200px' }}
            onChange={(e) => setSelectedColumn(e.target.value)}
          />
          <div style={{ color: 'var(--danger-500, red)' }}>{headerErrorModal || ''}</div>
          {/* <h4>Select Type</h4>
          <Select
            className="select-menu dmb-4"
            defaultValue=""
            style={{ width: '20%', marginRight: '10px' }}
            onChange={(e) => setSelectedColumnFromType(e)}
            showSearch
            placeholder='Select Type'
            value={selectedColumnFromType}
          >
            <Option value="">Select Type</Option>
            <Option value="string">String</Option>
            <Option value="double">Double</Option>
          </Select> */}

          <div className="modal-footer">
            <Button
              className={`modal-submit-button ${!selectedColumn ? 'disabled' : ''}`}
              onClick={() => {
                handleHeaderColumnChange('output');
              }}
              disabled={!selectedColumn}
            >
              Submit
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderModal;
